import Routes from "@/common/router/Routes";
import {customerRouter} from "@/context/customer/router/CustomerRouter";
import {
  remoteConfigurationRouter
} from "@/context/remote_configuration/router/RemoteConfigurationRouter";

export default class RemoteConfigurationRoutes extends Routes {
  constructor() {
    super({
      label: "Zdalna konfiguracja",
      router: remoteConfigurationRouter,
      lazyPage: () => import("@/context/remote_configuration/page/RemoteConfiguration.vue"),
      lazyCreate: () => import("@/context/remote_configuration/page/RemoteConfiguration.vue"),
      lazyUpdate: () => import("@/context/remote_configuration/page/RemoteConfiguration.vue"),
      lazyList: () => import("@/context/remote_configuration/container/RemoteConfigurationUploadListContainer.vue"),
      lazyShow: () => import("@/context/remote_configuration/container/RemoteConfigurationUploadDetailsContainer.vue"),
    });
    this.addChild({
      path: "upload",
      name: "upload",
      label: "Upload konfiguracji",
      visible: true,
      component: () => import("@/context/remote_configuration/container/RemoteConfigurationUploadContainer.vue"),
      url: `${this.router.basePath}/upload`
    });
    this.addChild({
      path: "download",
      name: "download",
      label: "Download konfiguracji",
      visible: true,
      component: () => import("@/context/remote_configuration/container/RemoteConfigurationDownloadContainer.vue"),
      url: `${this.router.basePath}/download`
    });
  }
}

export const remoteConfigurationRoutesConfig = new RemoteConfigurationRoutes().routeConfig;
